export const en = {
  translation: {
    // content
    "About-exp": "Experience:",
    "About-exp-details": `By education, I am a mechanical engineer, specializing in manufacturing technology. I have been officially working in front-end development since 2019. Before that, I spent some time learning HTML and CSS on my own. Overall, I am self-taught. I have no formal education related to programming, except for a Front-end course at Beetroot Academy. As of today, my commercial experience amounts to about 5 years. Although I am a front-end developer, I am currently trying myself in back-end development. I enjoy learning new things.`,
    "About-me": "About me:",
    "About-me-details": `I am a simple and open-minded person. An optimist with a sense of humor (but that’s not guaranteed). I love people — communication with others is my strong suit. Above all, I value honesty and modesty in people. I am stress-resistant, although I don’t like stressful situations (I guess, like all of us). My short-term goal is to become a full-stack engineer. My main interests are computer hardware, programming, games, and a bit of sports. When it comes to music, I listen to everything except chanson. I enjoy watching movies. My favorite genre is science fiction.`,
    "Projects page": "Welcome to my projects page",
    "Contact page": "My contact information",
    "Greetings": "Hi, my name is Vitaliy. Friends call me Vito.",
    "Live": "I`m from ",
    "Live-country": "Ukraine",
    "Live-earth": "our Earth",
    "Live-galaxy": "our Galaxy",
    "Live-universe": "our Universe",
    "Hero-description":
      "My creed: I like everything new. I don’t like to stand still.",
    "Email": "Email:",
    "Phone": "Phone number:",
    "niagara-mobile": "Web and mobile app for client of Niagara Club",
    "lkames": "Website for a small estimating company Lkames",
    "bp-manager": "Simple manager for collecting Bonus Points on GTA 5 RP",
    "description-website": "This portfolio site uses stack - React, Firebase",
    "another-projects": "My another project:",
    "snake-game": "Simple snake game. Just for fun.",
    //UI titles
    "[btn-name] About": "About me",
    "[btn-name] Projects": "My projects",
    "[btn-name] Contact": "Contact me",
    "[option-name] Language": "Lang: ",
    "theme-status-dark": "Light mode",
    "theme-status-light": "Dark mode"
  },
};
